import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";
import { isJson } from "utils/isJson";

export const getAllContractAsync = createAsyncThunk(
  "contract/getAllcontract",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/list-contract?page=${payload?.page || 1}&limit=${
        payload?.limit || 10
      }&search=${payload?.search || ""}&quotation=${payload.quotation}&customer=${
        payload.customer || ""
      }&lob=${payload.lob || ""}&site=${payload.site || ""}`,
      [],
      toolkit
    );
  }
);

export const deleteContractAsync = createAsyncThunk(
  "contract/deletecontract",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/contract/delete-contract/${payload}`,
      [],
      toolkit
    );
  }
);

export const createContractAsync = createAsyncThunk(
  "contract/contract",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/contract/create-contract`, payload, toolkit);
  }
);

export const getContractByIdAsync = createAsyncThunk(
  "contract/getcontractById",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/contract/get-contract/${payload}`, [], toolkit);
  }
);

export const getServiceByQuotationAsync = createAsyncThunk(
  "contract/get-quotation-service",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/get-quotation-service/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateContractAsync = createAsyncThunk(
  "contract/updatecontract",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/contract/update-contract/${payload.id}`,
      payload,
      toolkit
    );
  }
);

// Get Contract without pagination and search filter
export const getContractWithoutPaginationAsync = createAsyncThunk(
  "contract/getAllcontract",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/contract/list-contract`, [], toolkit);
  }
);

export const getContractDocumentDropdownAsync = createAsyncThunk(
  "contract/getContractDocumentDropdown",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/contract/list-document-dropdown/`, [], toolkit);
  }
);

// NEW: Get contract locations for service card generation
export const getContractLocationAsync = createAsyncThunk(
  "contract/getContractLocation",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/get-contract-location?contractId=${payload}`,
      [],
      toolkit
    );
  }
);

// NEW: Create service card with selected addresses
export const createServiceCardAsync = createAsyncThunk(
  "contract/createServiceCard",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/contract/create-service-card?contractId=${payload.contractId}`,
      { address: payload.address },
      toolkit
    );
  }
);

// DEPRECATED: Keep for backward compatibility if needed
export const generateServiceCardDownload = (contractId) => {
  const token = isJson(localStorage.getItem("auth"))
    ? JSON.parse(localStorage.getItem("auth"))?.token
    : null;
  const url = `${process.env.REACT_APP_BASE_URL}/contract/create-service-card?contractId=${contractId}&token=${token}`;
  window.open(url, "_blank");
};

export const getContractDocumentHtmlByDocumentIdAsync = createAsyncThunk(
  "contract/getContractDocumentHtmlByDocumentId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/contract/get-document-html/${payload?.documentId}/${payload?.contractId}`,
      [],
      toolkit
    );
  }
);

export const contractExcelDownloadAsync = ({
  search,
  quotation,
  customer,
  site,
}) => {
  window.open(
    `${process.env.REACT_APP_BASE_URL}/contract/contract-export-to-csv?token=${
      isJson(localStorage.getItem("auth"))
        ? JSON.parse(localStorage.getItem("auth"))?.token
        : null
    }&search=${search || ""}&customer=${customer || ""}&site=${site || ""}`,
    "_parent"
  );
};

export const contractEmailPdfAsync = createAsyncThunk(
  "contractEmailPdf",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/contract/save-pdf-and-mail/${payload.id}`,
      payload,
      toolkit
    );
  }
);